<template>
	<div class="hierarchy-header tw-px-16 tw-py-7 tw-flex">
		<div class="title tw-flex tw-items-center tw-pr-4">
			<h3 class="uppercase tw-m-0">Jerarquía de Puestos</h3>
		</div>
		<div class="description tw-items-center tw-pl-4">
			<p class="tw-m-0">Para seleccionar los subordinado de cada puesto se debe dar un click en uno de los puestos de trabajo</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'job-hierarchy-header',
};
</script>

<style lang="scss" scoped>
.hierarchy-header {
	.title {
		font-size: 18px !important;
		color: var(--app-color-primary);
	}
	.description {
		width: 350px;
		font-size: 12px;
		line-height: 12px;
		color: var(--app-color-info);
		border-left: solid 1px #969696;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-assignation/job-hierarchy-header.vue